import { useMemo } from "react";
import { useVisible } from "../../../../../utils/hooks/useVisible";
import MoveToOpenShifts from "../../components/modals/MoveToOpenShifts";

export const useMoveToOpenShiftsModal = () => {
    const { open, visible, selected, close } = useVisible();

    const modal = useMemo(() => {
        return (
            <MoveToOpenShifts 
                open={visible}
                values={selected}
                close={close}
            />
        );
    }, [close, selected, visible]);

    return { open, modal };
}
